import React from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemIcon from '@material-ui/core/ListItemIcon';

import IconButton from '@material-ui/core/IconButton';
import RemoveIcon from '@material-ui/icons/RemoveCircle';
import PDFIcon from '@material-ui/icons/PictureAsPdf';
import FileIcon from '@material-ui/icons/InsertDriveFile';

import { filterById, humanizeBytes, clipName } from './utils';

// TODO: preview for non images (icon)
var FilePreview = function FilePreview(_ref) {
  var type = _ref.type,
      parsed = _ref.parsed;

  var _type$split = type.split('/'),
      prefix = _type$split[0];

  return prefix === 'image' ? React.createElement(
    ListItemAvatar,
    null,
    React.createElement(Avatar, { style: { borderRadius: 0 }, alt: 'Preview', src: parsed })
  ) : React.createElement(
    ListItemIcon,
    null,
    type === 'application/pdf' ? React.createElement(PDFIcon, null) : React.createElement(FileIcon, null)
  );
};

var FileItem = function FileItem(_ref2) {
  var file = _ref2.file,
      onClick = _ref2.onClick;
  return React.createElement(
    ListItem,
    { alignItems: 'center' },
    React.createElement(FilePreview, file),
    React.createElement(ListItemText, {
      primary: clipName(file.name),
      secondary: humanizeBytes(file.size)
    }),
    React.createElement(
      ListItemSecondaryAction,
      null,
      React.createElement(
        IconButton,
        { edge: 'end', 'aria-label': 'Remove', onClick: onClick },
        React.createElement(RemoveIcon, { color: 'secondary' })
      )
    )
  );
};

var FilesList = function FilesList(_ref3) {
  var files = _ref3.files,
      setFiles = _ref3.setFiles;

  var filterFile = function filterFile(id) {
    return filterById(files, id);
  };
  var remove = function remove(id) {
    return function () {
      return setFiles(filterFile(id));
    };
  };
  return files.length ? React.createElement(
    React.Fragment,
    null,
    React.createElement(Divider, null),
    React.createElement(
      List,
      null,
      files.map(function (file, index) {
        return React.createElement(FileItem, { key: index, file: file, onClick: remove(file.id) });
      })
    )
  ) : null;
};

export default FilesList;